import * as React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import SIBuilt from "./SIBuilt";
import SiAntiFraud from "./SiAntiFraud";
import SiScalability from "./SiScalability";
import SiMonitoring from "./SiMonitoring";
import SiDashboard from "./SiDashboard";
import SiIntegration from "./SiIntegration";
import SiTroubleshooting from "./SiTroubleshooting";
import { siTabs } from "./SiTabs";

// Panels are keyed by SLUG, not by array position, so adding/removing a tab in
// `siTabs` can never leave the panels misaligned with the tabs.
const panelsBySlug = {
  "built-for-compliance": <SIBuilt />,
  "geolocation-anti-fraud": <SiAntiFraud />,
  "integration-scalability": <SiScalability />,
  monitoring: <SiMonitoring />,
  "dashboard-insights": <SiDashboard />,
  "si-Integration": <SiIntegration />,
  troubleshooting: <SiTroubleshooting />,
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      sx={{
        height: "100vh",
        overflowY: "auto",
        boxSizing: "border-box",
      }}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

function SiTabPanels({ value }) {
  // Derive the rendered panels from the tabs themselves, in tab order.
  const contentTabs = siTabs.filter((t) => !t.isHeader);

  return (
    <>
      {contentTabs.map((tab, index) => (
        <TabPanel key={tab.slug} value={value} index={index}>
          {panelsBySlug[tab.slug] ?? null}
        </TabPanel>
      ))}
    </>
  );
}

export default SiTabPanels;
